// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1QrHr","item":"PaymentsMobile_item__3k2Ph","label":"PaymentsMobile_label__81huE","amount":"PaymentsMobile_amount__1Z7Cd"};